/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import getHistory from '../../lib/HistoryHelper';
import { trackLink } from '../../lib/analytics-helper';
import * as shape from '../../contactUs/constants/PropTypesShapes';

const Breadcrumb = (props) => {
  const { items, action } = props;
  const history = getHistory();

  const push = (element, key, updateBreadcrumb) => {
    const breadcrumb = items.slice(0, key + 1);
    if (updateBreadcrumb) {
      updateBreadcrumb(breadcrumb);
    }
    trackLink({ id: 'articlePage', link: `smarthelp-breadcrumb-article-page|${element.title}` });
    history.push(`${element.path}`);
  };

  const handleKeyPress = (event, item, key, actions) => {
    if (event.which === 13) {
      push(item, key, actions);
    }
  };

  const renderBreadCrumb = () => {
    const itemList = items.map((item, key) =>
      <li
        className="breadcrumb-item"
        tabIndex="0"
        role="button"
        key={item.title}
        onClick={() => push(item, key, action)}
        onKeyPress={e => handleKeyPress(e, item, key, action)}
      >
        {item.title}
      </li>);
    return <ul className="article-breadcrumb-path">{itemList}</ul>;
  };

  return (<div className="article-breadcrumb">
    {renderBreadCrumb()}
  </div>);
};

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(shape.FAQ_ARTICLE)),
  action: PropTypes.func,
};
Breadcrumb.defaultProps = {
  items: [],
  action: undefined,
};

export default Breadcrumb;



// WEBPACK FOOTER //
// ./home/containers/Breadcrumb.js